import { render, staticRenderFns } from "./GameDailyAchievements.vue?vue&type=template&id=3a90bfde&"
import script from "./GameDailyAchievements.vue?vue&type=script&lang=js&"
export * from "./GameDailyAchievements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_ac830c93e858ec1d0aac5d048a5aa012/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports